import React from "react";
import { DialogActions } from "@mui/material";
import type { DialogActionsProps } from "@mui/material/DialogActions";
import { mergeSeeditDialogSx, seeditDialogActionsSx } from "./dialog-layout.styles";

export const SeeditDialogActions: React.FC<DialogActionsProps> = ({ sx, ...props }) => (
  <DialogActions sx={mergeSeeditDialogSx(seeditDialogActionsSx, sx)} {...props} />
);
